import moment from 'moment'

export default class JobComment {
  constructor(json) {
    this.id = json.id
    this.comment = json.comment
    this.submittedOn = json.submitted_on
    this.createdById = json.created_by
    this.createdOn = moment.utc(json.created).local()
  }

  id: string
  comment: string
  submittedOn: string
  createdById: string
  createdOn: moment.Moment
}
